import React from 'react';
import PropTypes from 'prop-types';
import {ButtonOutline, ButtonPrimary} from 'components/buttons';
import {EmptyHero} from 'routes/App/cashback/styles';
import EmptyCashback from 'assets/empty-cashback-img.svg';

const LEARN_MORE_URL = 'https://support.getsauce.com/cashback-how-it-works';
const GET_STARTED_URL =
  'https://share.hsforms.com/1ltpnwBKiRbSSLMibffSkQg21htm';

const CashbackEmptyState = ({showLimitedTimeOffer}) => {
  return (
    <EmptyHero>
      <img src={EmptyCashback} alt='Cashback' />
      <div className='heroTitle'>Turn first-time orders into regulars</div>
      <div className='heroSubtitle'>
        Launch your cashback program and watch customers come back for more.
      </div>
      <ul>
        <li>Customers earn credits on every order</li>
        <li>They come back to use them — driving repeat business</li>
        <li>
          You only pay when it works (credits cost you only when redeemed)
        </li>
      </ul>
      {showLimitedTimeOffer && (
        <div className='limitedTimeNotice'>
          <b>Cashback is free for a limited time!</b> Get started now and add it
          to your store.
        </div>
      )}
      <div className='heroActions'>
        <ButtonOutline
          className='ButtonMedium'
          onClick={() => window.open(LEARN_MORE_URL, '_blank')}
        >
          Learn how it works
        </ButtonOutline>
        <ButtonPrimary
          className='ButtonMedium'
          onClick={() => window.open(GET_STARTED_URL, '_blank')}
        >
          <span>Get started</span>
        </ButtonPrimary>
      </div>
    </EmptyHero>
  );
};

CashbackEmptyState.propTypes = {
  showLimitedTimeOffer: PropTypes.bool
};

CashbackEmptyState.defaultProps = {
  showLimitedTimeOffer: false
};

export default CashbackEmptyState;
